import useHolderServiceRequests from '@hooks/queries/registry/onboarding/useHolderServiceRequests';
import { useParties } from '../../contexts/PartiesContext';

export const useInboundHolderServiceRequests = () => {
  const { party } = useParties();
  const holderServiceRequests = useHolderServiceRequests();
  const filtered = holderServiceRequests.data?.filter((r) => r.payload.provider === party);
  return filtered || [];
};
